
console.log("Running");

  document.addEventListener("DOMContentLoaded", function () {
    function countUp(el) {
      let start = 0;
      let end = parseInt(el.getAttribute("data-count"));
     // let end = el.getAttribute("data-count");
      console.log('countup-value:',end, typeof end)
      console.log('count:', end)
      let durationSeconds = parseInt(el.getAttribute("data-duration")) || 5500; // Default to 5500 if no duration is provided
      let duration = durationSeconds * 1000; // Convert seconds to milliseconds

      if (!isNaN(end) && end > 1) {
      let increment = end / (duration / 16);

      function updateNumber() {
        start += increment;
        if (start < end) {
          el.innerText = Math.floor(start);
          requestAnimationFrame(updateNumber);
        } else {
          el.innerText = end;
          console.log('end:',end)
          
        }
      }
      updateNumber();
    }
  }

    let countUpElements = document.querySelectorAll(".countup");

    // Intersection Observer to trigger when numbers are in view
    let observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            countUp(entry.target);
            observer.unobserve(entry.target); // Stop observing after animation
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is in view
    );

    countUpElements.forEach((el) => {
      observer.observe(el);
    });
  });

